export default {
  aboutHero: {
    label: 'ABOUT DRA',
    title: 'DRAの理念',
  },
  philosophy: {
    label: 'THE INQUIRY',
    title: '必然を設計する、\n教育の再定義',
    quote: '教育とは、可能性を信じる「精神論」ではなく、\n可能性を現実化する「構造の提供」である。',
    body1: '私たちは、教育の現場における「不確実性」を問い続けてきました。なぜ、個人の資質や努力が、必ずしも持続的な成果に結びつかないのか。',
    body2: 'その根本的な要因は、個人の能力不足ではなく、個々人が無意識に保持している「認知の構造」と、それを再構築する「体系の欠如」にあります。',
    footer: 'DRAは、思考・行動・結果の連鎖を整理し、教育として体系化する機関です。',
  },
  founding: {
    label: 'CORE LOGIC',
    title: '18歳までの認知形成、\nその先へ',
    body1: '人間の意思決定の90%以上は、18歳までに形成された無意識の認知パターン（OS）に依存しています。',
    body2: 'DRAは、この内在する構造を客観的に可視化し、科学的視座に基づいた「DREAM CODE」によって、自律的な再設計（Re-structure）を支援します。',
    conclusion: '教育とは、可能性を信じる「精神論」ではなく、\n可能性を現実化する「構造の提供」であるべきだと考えます。',
    pillar1: { label: '認知', desc: '無意識の構造を可視化' },
    pillar2: { label: '再設計', desc: '科学的視座に基づく再構築' },
    pillar3: { label: '再現性', desc: '持続的成果の体系化' },
  },
  founder: {
    label: 'FOUNDER AS AN ARCHITECT',
    title: '創設者／理事長 廣瀬進二　メッセージ',
    subtitle: 'なぜ今、構造なのか',
    quote: '「私たちは、情熱ではなく、再現性を贈る。」',
    description: '思想の設計図としての創設者。DRAが提唱する構造化教育の本質と、個人・組織を本質的変革へ導く設計思想について語ります。',
  },
  award: {
    label: 'GLOBAL RECOGNITION',
    title: '国連で証明された、教育フレームワークの新基準',
    intro: '2026年3月、ニューヨークで開催された国連フォーラム。DRAが提唱する「構造化教育」の社会的意義と、個人・組織を本質的変革へ導く設計思想が評価され、国際的な表彰を受けました。これは一過性のブームではなく、次世代のグローバル・スタンダードとしての確固たる承認です。',
    year: '2026',
    location: 'NEW YORK',
    awardTitle: '国連CSW70関連フォーラム\n「Outstanding Contribution Award（卓越した貢献賞）」受賞',
    point1: '脳科学・行動心理学・AIを融合した独自メソッドの評価',
    point2: '女性のエンパワーメントおよび次世代リーダー育成への貢献',
    point3: '国連ECOSOC特別協議資格団体（IDIO）からの国際的承認',
    note: '社会発展と教育分野における顕著な貢献が認められ、国際社会へ向けた名誉ある賞を授与されました。精神論を排し、認知の「構造」からアプローチするDRAの革新性と実効性が、世界最高峰の舞台で証明されています。',
    buttonText: '受賞・活動の詳細を見る',
  },
};